import Vue from 'vue'
import Router from 'vue-router'
// import Api from '@/service/Api.vue'

Vue.use(Router)
import TextGroup from '@/components/form/TextGroup.vue'
import TextNumber from '../components/form/TextNumber.vue'
import LineDashed from '@/components/lte/LineDashed.vue'
import IboxTitle from '@/components/lte/IboxTitle.vue'
import Datepicker from 'vuejs-datepicker'
import TableRow from '@/components/table/Row.vue'
import Modal from '@/components/Modal.vue'
import Ibox from '@/components/lte/Ibox.vue'
import SelectPrefecture from '../components/form/SelectPrefecture.vue'
import SelectCity from '../components/form/SelectCity.vue'
import Pager from '@/components/Pager.vue'

// 登録命名規則
// フォルダ名+ファイル名 区切り文字にはハイフン?
// ※キャメルケースで登録した場合、<TextGroup><text-group>の両方が使えるのであまり良くないかも（コードの統一感が損なわれる）
Vue.component('alert-compact', require('../components/alert/Compact.vue'))
Vue.component('alert-error', require('../components/alert/Error.vue'))
Vue.component('alert-message', require('../components/alert/Message.vue'))
Vue.component('image-preview', require('../components/form/ImagePreview.vue'))
Vue.component('file-upload', require('../components/form/FIleUpload.vue'))
Vue.component('auto-textarea', require('../components/form/AutoTextArea.vue'))
Vue.component('text-group', TextGroup)
Vue.component('text-number', TextNumber)
Vue.component('select-station', require('../components/form/SelectStation.vue'))
Vue.component('select-prefecture', SelectPrefecture)
Vue.component('select-city', SelectCity)
Vue.component('line-dashed', LineDashed)

// ハイフンを使わないやつは特に利用頻度の高いもののみ
Vue.component('loading', require('../components/Loading.vue'))
Vue.component('pager', Pager)
Vue.component('ibox', Ibox)
Vue.component('ibox-title', IboxTitle)
Vue.component('modal', Modal)
Vue.component('Datepicker', Datepicker)
Vue.component('table-row', TableRow)

// 複数ページで使われるHJ個別のもの
Vue.component('company-list-row', require('../components/company/ListRow.vue'))
Vue.component('member-list-row', require('../components/member/ListRow.vue'))
Vue.component('company-review-list-row', require('../components/company/review/ListRow.vue'))

Vue.component('contact-list-row', require('../components/contact/ListRow.vue'))
Vue.component('contact-search', require('../components/contact/Search.vue'))

var moment = require('moment')

Vue.filter('dateFormat', function (value, format) {
  moment.lang('ja')
  return moment(value).format(format)
})

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      component: require('@/Login.vue')
    },
    {
      path: '/',
      component: require('@/Layout.vue'),
      // beforeEnter: (to, from, next) => {
      // ログイン無効
      // Api.token().then(function () {
      //   next()
      // }).catch(function () {
      //   location.href = '/'
      // })
      // },
      children: [
        {path: '/contact/', component: require('@/views/contact/List.vue')},
        {path: '/member/', component: require('@/views/member/List.vue'), meta: {nav: 'member'}},
        {path: '/member/create', component: require('@/views/member/Create.vue'), meta: {nav: 'member'}},
        {path: '/member/edit/:member_id', component: require('@/views/member/Edit.vue'), meta: {nav: 'member'}},
        {path: '/notice/', component: require('@/views/notice/List.vue')},
        {path: '/notice/edit/:alias', component: require('@/views/notice/Edit.vue')},
        {path: '/company/review/', component: require('@/views/company/review/List.vue'), meta: {nav: 'bill'}},
        {
          path: '/company/review/check',
          component: require('@/views/company/review/Check.vue'),
          meta: {nav: 'company'}
        },
        {
          path: '/company/review/create',
          component: require('@/views/company/review/Create.vue'),
          meta: {nav: 'company'}
        },
        {
          path: '/company/review/edit/:review_id',
          component: require('@/views/company/review/Edit.vue'),
          meta: {nav: 'company'}
        },

        // その他

        {path: '/company/', component: require('@/views/company/List.vue'), meta: {nav: 'bill'}},
        {path: '/company/create', component: require('@/views/company/Create.vue'), meta: {nav: 'bill'}},
        {path: '/company/:company_id', component: require('@/views/company/Edit.vue'), meta: {nav: 'bill'}},
        {path: '*', component: require('@/views/NotFound')}
      ]
    }
  ],
  scrollBehavior (to, from, savedPosition) {
    return {x: 0, y: 0}
  }
})




// WEBPACK FOOTER //
// ./src/router/index.js